<template>
<div>edit</div>
</template>

<script>
export default {
  name: 'EditPersonalReservation',
}
</script>

<style scoped>

</style>
